type ErrorFallbacks = Record<string, string>;

type LanguageFallbacks = Record<string, ErrorFallbacks>;

export const ERROR_FALLBACKS: LanguageFallbacks = {
  'en-GB': {
    user_under_age:    'You need to be 18 or older to join the fun.',
    user_age_error:    'Hmm, that birth date looks a bit funky. Check it and correct it! Thanx',
    birthday_required: 'This field is required.',
  },
  'es-ES': {
    user_under_age: 'Debes tener 18 años o más para unirte a la fiesta.',
    user_age_error:
      'Hmm, esa fecha de nacimiento no nos cuadra. Échale un ojo y corrígela. ¡Gracias!',
    birthday_required: 'Por favor, introduce tu fecha de nacimiento',
  },
  'fi-FI': {
    user_under_age: 'Sinun tulee olla vähintään 18-vuotias, jotta voit liittyä mukaan hauskanpitoon.',
    user_age_error:
      'Hmm, tuo syntymäaika näyttää hieman omituselta. Tarkista ja korjaa se. Kiitos paljon.',
    birthday_required:  'Anna syntymäpäiväsi',
    piq_payment_failed: 'Maksu epäonnistui. Yritä uudelleen.',
  },
  'en-NZ': {
    user_under_age:    'You need to be 18 or older to join the fun.',
    user_age_error:    'Hmm, that birth date looks a bit funky. Check it and correct it! Thanx',
    birthday_required: 'This field is required.',
  },
};

export const GENERIC_FALLBACK: Record<string, string> = {
  'es-ES': '¡Ups! Algo ha salido mal. Inténtalo de nuevo más tarde.',
  'fi-FI': 'Hups! Jotain meni vikaan. Yritä myöhemmin uudelleen.',
};
